import { ProductFilterLinkClass } from "./products-filter-link-class";

// eslint-disable-next-line import/prefer-default-export
export class ProductsFilterLinkDesktopClass extends ProductFilterLinkClass {
  #disabled = false;

  #savedStatues = false;

  constructor(props) {
    super(props);

    // Fix for the issue where the page is loaded from cache
    window.addEventListener("pageshow", event => {
      if (event.persisted) {
        this.#disabled = false;
        this.#savedStatues = false;
        this.#updateActualInputStatuses();
      }
    });
  }

  #saveCheckedState() {
    this.$links.forEach($link => {
      const $input = ProductFilterLinkClass.$input($link);
      if ($input) {
        $input.dataset.defaultChecked = $input.checked;
      }
    });
    this.#savedStatues = true;
  }

  #updateActualInputStatuses() {
    this.$links.forEach($link => {
      const $input = ProductFilterLinkClass.$input($link);
      const defaultCheckedStatus = $input.dataset.defaultChecked;
      if (!defaultCheckedStatus) return; // Skip if no default checked state is set
      const isChecked = defaultCheckedStatus === "true";
      if (isChecked) {
        $input.setAttribute("checked", "checked");
        $input.checked = true;
      } else {
        $input.removeAttribute("checked");
        $input.checked = false;
      }
    });
  }

  event(event, $target) {
    event.preventDefault();
    event.stopPropagation();

    if (this.#disabled) return;

    if (!this.#savedStatues) this.#saveCheckedState();
    super.event(event, $target);

    this.#disabled = true;

    this.manualSubmit();
  }
}
